import { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import Spinner from "../components/common-components/Spinner";
import BalanceDetails from "../components/dashboard/BalanceDetails";
import { exitMarketAction } from "../redux/actions/currenciesActions";
import { getUserBinanceAccountInfoAction } from "../redux/actions/userActions";
import { dashboardAccountDetails, openPositionsHeaderList } from "../staticData/transactions";
import { fillRemainingDataGaps } from "../utils/common-functions";

class Dashboard extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.props.isDarkMode !== nextProps.isDarkMode ||
            this.props.spinnerStatus != nextProps.spinnerStatus ||
            this.props.userInfo !== nextProps.userInfo
        ) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.props.getUserBinanceAccountInfoAction();
    }

    render() {
        const isDarkMode = this.props.isDarkMode;
        const userInfo = this.props.userInfo;
        const spinnerStatus = this.props.spinnerStatus;
        const positionSides = {
            LONG: "BUY",
            SHORT: "SELL"
        };

        return (
            <div className="w-full flex flex-col items-center ">
                {spinnerStatus ? (
                    <Spinner
                        toggleValue={spinnerStatus}
                        props={{
                            parentDiv: {
                                style: { zIndex: 100 },
                                className: "loader"
                            },
                            spinnerIcon: {
                                style: {},
                                className: "loader-icon"
                            }
                        }}
                    />
                ) : null}
                <div
                    className={` flex min-h-14 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    } w-full`}>
                    <div className="flex-1 flex justify-center items-center text-2xl">
                        Dashboard
                    </div>
                    <div className="flex-5 hidden"></div>
                    <div className="flex-1 hidden"></div>
                </div>
                <div className="flex-15 flex flex-col  items-center  ">
                    <div className="flex w-10/12 flex-col mt-3 items-center py-4">
                        <BalanceDetails
                            isDarkMode={isDarkMode}
                            balanceDetails={userInfo.balanceDetails}
                            getUserBinanceAccountInfoAction={() =>
                                !this.props.spinnerStatus &&
                                this.props.getUserBinanceAccountInfoAction()
                            }
                        />

                        <div className=""></div>
                    </div>
                    <div className="overflow-x-auto primaryScroll mb-4 w-10/12 border-1 ">
                        <div className={"w-full max-w-30"}>
                            <div
                                className={`flex w-full ${
                                    this.props.isDarkMode
                                        ? "bg-secondaryDark "
                                        : "bg-secondaryLight "
                                } `}
                                style={{
                                    minWidth: 100 * openPositionsHeaderList.length
                                }}>
                                {openPositionsHeaderList?.map((thValue, index) => {
                                    return (
                                        <>
                                            <div
                                                className={"text-center text-xs py-3 min-w-16 "}
                                                key={index}>
                                                {thValue}
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                            <div className={""}>
                                {fillRemainingDataGaps([...userInfo.openPositionsList], 10, {
                                    symbol: "",
                                    initialMargin: "",
                                    maintMargin: "",
                                    unrealizedProfit: "",
                                    positionInitialMargin: "",
                                    openOrderInitialMargin: "",
                                    leverage: "",
                                    isolated: "",
                                    entryPrice: "",
                                    maxNotional: "",
                                    positionSide: "",
                                    positionAmt: "",
                                    notional: "",
                                    isolatedWallet: "",
                                    updateTime: "",
                                    bidNotional: "",
                                    askNotional: ""
                                }).map((tbRow) => {
                                    const {
                                        askNotional,
                                        bidNotional,
                                        entryPrice,
                                        initialMargin,
                                        isolated,
                                        isolatedWallet,
                                        leverage,
                                        maintMargin,
                                        maxNotional,
                                        notional,
                                        openOrderInitialMargin,
                                        positionAmt,
                                        positionInitialMargin,
                                        positionSide,
                                        symbol,
                                        unrealizedProfit,
                                        updateTime
                                    } = tbRow;
                                    const currencyId = symbol?.split("USDT")[0];
                                    if (
                                        this.props?.currenciesList[currencyId]?.operations
                                            ?.isBinanceOn
                                    ) {
                                        return (
                                            <>
                                                <div
                                                    key={symbol + initialMargin}
                                                    style={{
                                                        minWidth:
                                                            100 * openPositionsHeaderList.length
                                                    }}
                                                    className={` text-center flex min-h-10   even:${
                                                        isDarkMode
                                                            ? "bg-secondaryDark "
                                                            : "bg-secondaryLight "
                                                    } ${
                                                        isDarkMode
                                                            ? "even:bg-secondaryDark even:text-[#000]"
                                                            : "even:bg-secondaryLight even:text-black"
                                                    }`}>
                                                    {/* {tbArray?.map(tdValue => {
                                                    return <td {String(tdValue)}</td>
                                                })} */}
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {symbol}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {initialMargin}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {maintMargin}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {unrealizedProfit}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {positionInitialMargin}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {openOrderInitialMargin}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {leverage}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {String(isolated)}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {entryPrice}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {maxNotional}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {positionSide}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {positionAmt}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {notional}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {isolatedWallet}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {updateTime}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {bidNotional}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className="min-h-11 basis-1/2 flex-1 flex items-center justify-center">
                                                        {askNotional}
                                                    </div>
                                                    <div
                                                        style={{ minWidth: 100 }}
                                                        className={`flex justify-center items-center text-center  text-vsm lg:text-sm ${
                                                            entryPrice
                                                                ? "hover:bg-secondaryRed  hover:text-white cursor-pointer "
                                                                : ""
                                                        } `}
                                                        onClick={() =>
                                                            this.props.exitMarketAction({
                                                                currencyId,
                                                                entrySide:
                                                                    positionSides[positionSide],
                                                                storeInDb: false,
                                                                binanceMode: true
                                                            })
                                                        }>
                                                        {entryPrice !== "" ? "Market" : ""}
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Dashboard</title>
                </Helmet>
                <ToastContainer />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUserBinanceAccountInfoAction: () => dispatch(getUserBinanceAccountInfoAction()),
        exitMarketAction: ({ currencyId, entrySide, storeInDb, binanceMode }) =>
            dispatch(
                exitMarketAction({
                    entrySide,
                    storeInDb,
                    currentCurrencyId: currencyId,
                    binanceMode
                })
            )
    };
};

const mapStateToProps = (state) => {
    const { spinnerStatus, isDarkMode, userInfo, currenciesList } = state.persistedReducer;

    return {
        spinnerStatus,
        isDarkMode,
        userInfo,
        currenciesList
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
